export default __webpack_public_path__ + "static/reDreamLogo_light-cedd29c2e4cce76bf56ca674bcaa3ed6.svg";